<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15uL43D/tc-custom/9781446351079.jpg?1720120983952" alt="This image is the cover for the book Layer Cake, Jelly Roll and Charm Quilts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Layer Cake, Jelly Roll and Charm Quilts
      </h1>
      <p class="bookDescription body article font2">
        <b>Clever techniques for using precut fabric collections from the bestselling authors whose jelly roll books have sold over 300,000 copies!</b><br/>  <br/><i>Layer Cake, Jelly Roll and Charm Quilts</i> provides seventeen beautiful projects that show readers how to get the most from their precut fabric bundles. The projects range from smaller lap quilts to full-sized bed quilts, and each is made from one jelly roll, layer cake, charm pack, or a combination, making the quilts quick and economical. Using the latest fabrics, the authors provide a main quilt and an alternative colorway for added versatility. Simple step-by-step instructions and illustrations make creating quilts from bundles accessible to quilters of all abilities.<br/>  <br/> Published with the support of Moda Fabrics.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pam Lintott, Nicky Lintott
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      D&C
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2459bc6e